import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { BPBoxWithHeader } from './BPBoxWithHeader';

interface IItemsListProps {
    header?: string | React.ReactNode;
    items: Array<any>;
    renderRow: (item: any, index: number) => React.ReactNode;
    scrolling?: boolean;
    filter?: (item: any, filterText: string) => boolean;
}

const ItemsList: React.FunctionComponent<IItemsListProps> = ({ header, items, renderRow, scrolling, filter }) => {
    const [filteredItems, setFilteredItems] = React.useState<Array<any>>(items)

    return <BPBoxWithHeader
        header={header}
        scrolling={scrolling}
        onFilter={filter ? (filterText) => {
            setFilteredItems(items.filter((item) => filter(item, filterText)))
        } : null}>
        <Table striped
            tableData={filteredItems}
            renderBodyRow={renderRow}>
        </Table>
    </BPBoxWithHeader>;
};

export default ItemsList;
